import { render, staticRenderFns } from "./dataVieweight.vue?vue&type=template&id=2a4e9fa4&scoped=true"
import script from "./dataVieweight.vue?vue&type=script&lang=js"
export * from "./dataVieweight.vue?vue&type=script&lang=js"
import style0 from "./dataVieweight.vue?vue&type=style&index=0&id=2a4e9fa4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4e9fa4",
  null
  
)

export default component.exports